import { render, staticRenderFns } from "./forgot-password-request.vue?vue&type=template&id=68d1d2df&scoped=true"
import script from "./forgot-password-request.vue?vue&type=script&lang=js"
export * from "./forgot-password-request.vue?vue&type=script&lang=js"
import style0 from "./forgot-password-request.vue?vue&type=style&index=0&id=68d1d2df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d1d2df",
  null
  
)

export default component.exports